"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Header-Learner.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    SmallScreenHeader_template = require("./SmallScreenHeader.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    SmallScreenHeader_tag = marko_loadTag(SmallScreenHeader_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "pb-2 zindex-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("08e61d"),
    marko_node0 = marko_createElement("br", {
        "class": "d-md-block d-none"
      }, "2", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "col"
      },
    marko_attrs2 = {
        "class": "user-name mt-1 d-flex align-items-center"
      },
    marko_node2 = marko_createElement("i", {
        "class": "bx bxs-smile font-large-1 orange-text mx-1"
      }, "9", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  SmallScreenHeader_tag({}, out, __component, "0");

  const { intro, concern, assessment, ranking } = input

  out.be("div", marko_attrs0, "1", component);

  out.n(marko_node0, component);

  out.n(marko_node1, component);

  Row_tag({
      class: "m-0 d-flex align-items-center",
      renderBody: function(out) {
        out.be("div", marko_attrs1, "5", component);

        if (intro) {
          Locale_tag({
              text: intro,
              class: "text-muted"
            }, out, __component, "6");
        }

        if (concern) {
          out.be("h4", marko_attrs2, "7", component);

          Locale_tag({
              text: concern
            }, out, __component, "8");

          out.n(marko_node2, component);

          out.ee();
        }

        out.ee();
      }
    }, out, __component, "4");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
